import { FAILURE, POST, SUCCESS, GET, PUT, DELETE } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";
import { FORMATO_FECHA } from "../utils/const/formato-fecha";
import moment from "moment";

export async function subirFile(obj) {
    try {
        let data = { error: true };
        const { code, body, message, } = await fetch(
            `${BASE_URL}/upload-file/upload`,
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
                // body: JSON.stringify({ usuario, password }),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
            data.body = null;
        }
        // console.log('data');
        // console.log(data);
        return data;
    } catch (err) {
        console.log("subirFile err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function eliminarFile(obj) {
    try {
        let data = { error: true };
        const { code, body, message, } = await fetch(
            `${BASE_URL}/upload-file/delete`,
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
                // body: JSON.stringify({ usuario, password }),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
            data.body = null;
        }
        // console.log('data');
        // console.log(data);
        return data;
    } catch (err) {
        console.log("eliminarFile err");
        console.log(err);
        return { error: true, message: err };
    }
}